// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3GYAh","col":"Table_col__jAk4O","fulfillmentStatus":"Table_fulfillmentStatus__1biLT","emailCol":"Table_emailCol__2UoI3"};